export default {
  RatingCriterias: "RatingCriterias",
  AddRatingCriterias: "AddRatingCriterias",
  editRatingCriterias: "EditRatingCriterias",
};
